type Props = {
  className?: string;
};

export default function CloseIcon({ className }: Props) {
  return (
    <svg
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="7.55 7.56 17.89 17.89"
      className={className}
    >
      <title>Close Icon</title>
      <rect
        x="25.4448"
        y="9.18152"
        width="23"
        height="2.3"
        rx="0.5"
        transform="rotate(135 25.4448 9.18152)"
        fill="currentColor"
      ></rect>
      <rect
        x="9.18164"
        y="7.55518"
        width="23"
        height="2.3"
        rx="0.5"
        transform="rotate(45 9.18164 7.55518)"
        fill="currentColor"
      ></rect>
    </svg>
  );
}
